import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { TextEllipsisWrapper } from '@shared/utils/formatting/textEllipsis';
import { SkeletonText } from '@shared/components/Skeleton';

interface HotelTileHeaderProps
  extends Readonly<{
    displayName: string;
  }> {}

export const HotelTileHeader: React.FC<HotelTileHeaderProps> = ({ displayName }) => {
  return (
    <Box>
      <TextEllipsisWrapper
        typographyVariant="hed2"
        fontFamily="Inter UI"
        fontWeight={600}
        color="mono14"
        title={displayName}
      >
        {displayName}
      </TextEllipsisWrapper>
    </Box>
  );
};

// Skeleton component for HotelTileHeader
export const HotelTileHeaderSkeleton: React.FC = () => {
  return (
    <SkeletonText
      rows={1}
      width="80%"
      skeletonHeight={pxToRem(20)}
    />
  );
};
